import { render, staticRenderFns } from "./AppointmentsDashboard.vue?vue&type=template&id=daba1c6c&scoped=true&"
import script from "./AppointmentsDashboard.vue?vue&type=script&lang=js&"
export * from "./AppointmentsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentsDashboard.vue?vue&type=style&index=0&id=daba1c6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daba1c6c",
  null
  
)

export default component.exports